import { withInstall, withNoopInstall } from "@xplus/utils/with-install";
import Breadcrumb from "./src/breadcrumb.vue";
import BreadcrumbItem from "./src/breadcrumb-item.vue";
export const xBreadcrumb = withInstall(Breadcrumb, { BreadcrumbItem });
export const xBreadcrumbItem = withNoopInstall(BreadcrumbItem);
export default xBreadcrumb;
